import { makeAutoObservable, runInAction } from "mobx";
import Api from "../Components/Api";
import { BASE_API_URL } from "../Components/const";

class FilmStore {
  lastRequestParams = {
    numberPage: 1,
    query: "",
    body: {},
  };

  responseFilmList = null;
  responseListChannels = null;

  // === Новое поле по заданию ===
  addAfterData = null; // { channel_id, timeline_id }

  constructor() {
    makeAutoObservable(this);

    this.channel = new BroadcastChannel("film_channel");

    this.channel.onmessage = (event) => {
      if (event.data.type === "filmListUpdated") {
        console.log("📡 Получен сигнал на обновление списка фильмов");
        this.repeatLastFilmListRequest(true);
      }
    };
  }

  setLastRequestParams(params) {
    this.lastRequestParams = {
      ...this.lastRequestParams,
      ...params,
    };
  }

  setResponseFilmList(data) {
    this.responseFilmList = data;
  }

  setResponseListChannels = (data) => {
    this.responseListChannels = data;
  };

  // === Новые методы ===
  setAddAfterData(channel_id, timeline_id) {
    this.addAfterData = { channel_id, timeline_id };
  }

  clearAddAfterData() {
    this.addAfterData = null;
  }

  repeatLastFilmListRequest = (fromBroadcast = false) => {
    const { numberPage, query, body } = this.lastRequestParams;

    Api.post(`${BASE_API_URL}/api/filter?page=${numberPage}${query}`, body)
      .then((response) => {
        console.log("✅ Повторный запрос выполнен");
        this.setResponseFilmList(response);

        if (!fromBroadcast) {
          this.channel.postMessage({
            type: "filmListUpdated",
          });
        }
      })
      .catch((error) => {
        console.log("❌ Ошибка при повторном запросе:");
        console.error("❌ Ошибка при повторном запросе:", error);

        const msg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "❌ Ошибка при повторном запросе:";

        alert(`Ошибка: ${msg}`);
      });
  };

  async getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      runInAction(() => {
        this.responseListChannels = response.data.data;
      });
    } catch (error) {
      console.error("Ошибка при получении списка каналов:", error);
    }
  }
}

const filmStore = new FilmStore();
export default filmStore;
